module.exports = __webpack_public_path__ + "static/media/crm_img2.10ccb40c.jpg";